import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { NOURIA_SUPPORT_EMAIL } from './NouriaSupport';

/* Must agree with Nouria's PrivacyInfo.xcprivacy and the App Privacy questionnaire.
   Rewrite the prose freely; do not change a fact. */
const EFFECTIVE_DATE = '26 September 2026';

export default function NouriaPrivacy() {
  useEffect(() => {
    document.title = 'Nouria Privacy Policy';
    return () => { document.title = 'The Pantry Life'; };
  }, []);

  return (
    <div className="nouria-container">
      <div className="nouria-prose">
        <span className="nouria-overline">Nouria</span>
        <h1>Privacy Policy</h1>
        <p className="nouria-page-meta">Effective {EFFECTIVE_DATE}</p>

        <h2>Who we are</h2>
        <p>
          Nouria is made by The Pantry Life. If you have a question about this policy or about
          your data, email{' '}
          <a href={`mailto:${NOURIA_SUPPORT_EMAIL}`}>{NOURIA_SUPPORT_EMAIL}</a>.
        </p>

        <h2>What Nouria collects: nothing</h2>
        <p>
          Nouria has no accounts and no sign-in. It contains no analytics, no crash
          reporting, no advertising and no tracking of any kind. Nouria does not build a
          profile of you, and it does not share data with third parties for their own
          purposes.
        </p>

        <h2>Where your health data lives</h2>
        <p>
          Your supplements, your test results, the readings imported from the Health app,
          and the photographs you take all stay in Nouria's own storage on your phone. None
          of it is uploaded to us, backed up by us, or readable by us.
        </p>

        <h2>What leaves the phone, and only when you ask</h2>
        <p>
          Three things can leave your phone. Each one happens only as the direct result of
          an action you take:
        </p>
        <ol>
          <li>A photograph of a supplement label, when you ask Nouria to read it.</li>
          <li>A photograph or PDF of a test result, when you ask Nouria to import it.</li>
          <li>
            A question you type to the assistant, together with a short summary of the
            records needed to answer it.
          </li>
        </ol>
        <p>
          These go to Nouria's own service, which passes them to OpenAI to be read or
          answered and returns the result to your phone. Neither Nouria's service nor
          OpenAI retains them. Nothing is stored, nothing is logged as content, and nothing
          is used to train any model.
        </p>
        <p>
          On iPhones with Apple Intelligence, the free tier does this work entirely on the
          device, and nothing leaves the phone at all.
        </p>

        <h2>Health app data</h2>
        <p>
          With your permission, Nouria reads heart rate, heart rate variability, sleep,
          weight, steps, blood pressure and glucose from Apple Health, and uses them only to
          chart them alongside your results. Nouria never writes to the Health app. Health
          data is never used for advertising and is never shared.
        </p>

        <h2>Children</h2>
        <p>Nouria is not directed at children and is rated 17+.</p>

        <h2>Payments</h2>
        <p>
          Nouria Plus is sold through Apple. We never see your payment details. Apple tells
          us only whether a subscription is valid.
        </p>

        <h2>Your rights</h2>
        <p>
          Because nothing is held on our side, there is nothing for us to export or erase.
          Deleting a record in the app removes it and its photographs, and deleting the app
          removes everything. Questions go to the support address above.
        </p>

        <h2>Changes</h2>
        <p>
          Material changes will be posted on this page with a new effective date.
        </p>

        <h2>Not medical advice</h2>
        <p>
          Nouria provides general information about your own records. It is not a medical
          device, and it does not diagnose, treat or prescribe. Always speak to a qualified
          clinician about your health.
        </p>

        <p className="nouria-body-small nouria-secondary">
          Need help with the app? See <Link to="/nouria/support">Nouria support</Link>.
        </p>
      </div>
    </div>
  );
}
